module.exports = "/images/veheri-logo.png?adc60b423a803a8ca9f0660fa0c5c7a6";